import { render } from "./ShowClientAttributeMaster.vue?vue&type=template&id=2d8b9a96"
import script from "./ShowClientAttributeMaster.vue?vue&type=script&lang=js"
export * from "./ShowClientAttributeMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__